// ========== 全站背景 ==========
// 支持三种模式: starfield(静态星点) / image(自定义图片) / off(关闭)
// 注意：星空已降级为静态极淡装饰，不带动画，避免干扰阅读。

import React, { useEffect, useMemo } from 'react';
import { useBackgroundStore } from '@/store/useBackgroundStore';

const STAR_COUNT = 48;

const SpaceBackground: React.FC = () => {
  const mode = useBackgroundStore((s) => s.mode);
  const customImage = useBackgroundStore((s) => s.customImage);

  // 控制 class，使内容区背景透明
  useEffect(() => {
    if (mode !== 'off') {
      document.documentElement.classList.add('space-bg-active');
    } else {
      document.documentElement.classList.remove('space-bg-active');
    }
    return () => document.documentElement.classList.remove('space-bg-active');
  }, [mode]);

  // 星星位置（仅在挂载时生成，静态）
  const stars = useMemo(() => {
    const arr: Array<{
      id: number;
      left: number;
      top: number;
      size: number;
      opacity: number;
    }> = [];
    for (let i = 0; i < STAR_COUNT; i++) {
      arr.push({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: Math.random() * 1.5 + 0.5,
        opacity: Math.random() * 0.35 + 0.15,
      });
    }
    return arr;
  }, []);

  if (mode === 'off') return null;

  // 自定义图片模式（无图片时回退到星空）
  if (mode === 'image') {
    if (customImage) {
      return (
        <div
          className="space-bg space-bg-image"
          style={{ backgroundImage: `url(${customImage})` }}
        />
      );
    }
    // 没有自定义图片时回退星空
  }

  // 星空模式（静态星点 + 极淡星云）
  return (
    <div className="space-bg">
      {stars.map((star) => (
        <div
          key={star.id}
          className="space-bg-star"
          style={{
            left: `${star.left}%`,
            top: `${star.top}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            opacity: star.opacity,
          }}
        />
      ))}
      <div className="space-bg-nebula space-bg-nebula--1" />
      <div className="space-bg-nebula space-bg-nebula--2" />
      <div className="space-bg-nebula space-bg-nebula--3" />
    </div>
  );
};

export default React.memo(SpaceBackground);
